<select class="form-control" (change)="state.refine(select.selectedOptions[0].value)" #select>
  <option *ngFor="let item of state?.items; index as i" [value]="item.value" [selected]="item?.isRefined">
    {{ item?.label }}
  </option>
</select>
